export default "__VITE_ASSET__DZ6AYacO__"